import { get, post, serialize } from '../httpClient';

export const availabilityExceptionsAPI = {
  query: params => get('/api/availability-exceptions/query', params),
  createMultiple: body => post('/api/availability-exceptions/create-multiple', serialize(body)),
  delete: body => post('/api/availability-exceptions/delete', serialize(body)),
  deleteMultiple: body => post('/api/availability-exceptions/delete-multiple', serialize(body)),
};